import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import { nextYears } from '../../../../utils/dates';

function ReportsAggregatorMonthlyModalForm({
  setSpinner,
  close,
  createReport,
  aggregators,
  getAggregators,
}) {
  const [aggregatorId, setAggregatorId] = useState('');
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');

  useEffect(() => {
    (async () => {
      setSpinner(true);
      await getAggregators();
      setSpinner(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = () => {
    if (!year) {
      toast.error('Year is required');

      return;
    }

    if (!month) {
      toast.error('Month is required');

      return;
    }

    createReport({
      aggregatorId: aggregatorId ? Number(aggregatorId) : null,
      year: Number(year),
      month: Number(month),
    });
  };

  return (
    <>
      <Row className="align-items-center">
        <Col md={4} className="bo-same-line">
          <Form.Label>Aggregator:</Form.Label>
        </Col>
        <Col md={8} className="bo-same-line">
          <Form.Select
            className="bo-filter bo-w-250"
            value={aggregatorId}
            onChange={e => setAggregatorId(e.target.value)}
          >
            <option value="">All Standard Aggregators</option>
            {aggregators.map(agg => (
              <option key={agg.id} value={agg.id}>
                {agg.name}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="mt-2 mb-2 align-items-center">
        <Col md={4} className="bo-same-line">
          <Form.Label>Year:</Form.Label>
        </Col>
        <Col md={8} className="bo-same-line">
          <Form.Select
            className="bo-filter bo-w-250"
            value={year}
            onChange={e => setYear(e.target.value)}
          >
            <option value="">Select Year</option>
            {nextYears(8, 2023).map(y => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="mt-0 mb-2 align-items-center">
        <Col md={4} className="bo-same-line">
          <Form.Label>Month:</Form.Label>
        </Col>
        <Col md={8} className="bo-same-line">
          <Form.Select
            className="bo-filter bo-w-250"
            value={month}
            onChange={e => setMonth(e.target.value)}
          >
            <option value="">Select Month</option>
            {[...Array(12).keys()].map(m => (
              <option key={m} value={m + 1}>
                {m + 1}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="mt-auto">
        <Col className="d-flex justify-content-center gap-3">
          <Button className="bo-button" onClick={handleCreate}>
            Create
          </Button>
          <Button className="bo-button" onClick={close}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default ReportsAggregatorMonthlyModalForm;
